import { QueryClient } from "@tanstack/react-query";
import { WorkOrderWithAppointments } from "@myapp/contract";
import { workOrderKeys } from "../work-order.keys";
import { auditLogKeys } from "../../../audit-log";

/**
 * What every contact mutation does with its answer. The API returns the whole work order, so the
 * detail page is written from it directly — the counter moves with the click. The list shows the
 * count as a chip, and the audit log has just gained a line.
 */
export function applyContactResult(
  queryClient: QueryClient,
  workOrderId: string,
  data: WorkOrderWithAppointments,
): void {
  queryClient.setQueryData(workOrderKeys.detail(workOrderId), data);
  queryClient.invalidateQueries({ queryKey: workOrderKeys.lists() });
  queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(workOrderId) });
}
